module.exports = __webpack_public_path__ + "static/media/mayolie_contact.0cb995f9.png";